import { useCallback, useEffect, useState} from "react";
import { useDispatch, useSelector } from "react-redux";
import AssetInformation from "./AssetInformation";
import TransferApprovalDispatch from 'Store/Transfer/TransferApproval/TransferApprovalDispatch';
import { setTransferApprovalRequestOption, setTransferOrderApprovalRequest, setIsTransferItemAndOrderLevelApproval, setAssetApprovalData } from "Store/Transfer/TransferApproval/TransferApprovalAction";
import permissions, { isAuthorized } from 'client/utils/Permissions';
import userProfileSelectors from 'redux/UserProfile/selectors';
import navOperations from 'redux/Navigation/operations';
import Rejected from '../../../../../../assets/images/Rejected.svg'
import Approved from '../../../../../../assets/images/PenndingApproval/Approved.svg'
import Moreinfo from '../../../../../../assets/images/PenndingApproval/More Info.svg'
import { CONSTANTS } from "client/utils/constants";

const AssetInformationContainer = (props?: any) => {
  const assetOrderByIdItem = props?.assetOrderByIdItem;
  const assetOrderByIdIndex = props?.assetOrderByIdIndex;  
  const detailsByIdItem = props?.detailsByIdItem;
  const requesttype = props?.requesttype;

const dispatch = useDispatch();

  const {
    transferOrderByIdData,
    transferApproverActionData,    
    getUserDetails,
    transferOrderApprovalRequest,
    transferApprovalRequestOption,
    afeOrderByIdData
  }: any = useSelector((state: any) => ({
    transferOrderByIdData: state.TransferOrderReducer.transferOrderByIdData,
    transferApproverActionData: state.TransferApprovalReducer.transferApproverActionData,    
    getUserDetails: userProfileSelectors.getUserDetails(state),
    transferOrderApprovalRequest: state.TransferApprovalReducer.transferOrderApprovalRequest,
    transferApprovalRequestOption: state.TransferApprovalReducer.transferApprovalRequestOption,
    afeOrderByIdData: state.TransferReducer.afeOrderByIdData
  }));
  
  const dispatchTransferGetApproverActionData = TransferApprovalDispatch.dispatchTransferGetApproverActionData(dispatch);
  const dispatchNav = navOperations.dispatchNav(dispatch);
  const [requestOption, setRequestOption] = useState<any>([]);
  const [approverActionList, setApproverActionList] = useState<any>([]);
  const [selectedOption, setSelectedOption] = useState(requestOption[assetOrderByIdIndex]);

  useEffect(() => {
    setSelectedOption(requestOption[assetOrderByIdIndex]);
  }, [requestOption])

  const [searchFilter, setSearchFilter] = useState<any>('');
  const searchFilterChange = (event: any, option: any) => {
    setSearchFilter(option.key);
  }

  useEffect(() => {
    dispatch(setAssetApprovalData({}))
    dispatchTransferGetApproverActionData();
    return () => {
      dispatch(setTransferApprovalRequestOption([]))
    }
  }, [])

  useEffect(() => {
    
    if (transferApproverActionData && transferApproverActionData?.length > 0) {
      const newList: any = [];
      transferApproverActionData?.forEach((item: any) => {
        switch (item.key) {
          case "Request More Info":
            newList[0] = { ...item, disabled: !isAuthorized(permissions.ApprovalsReturnToRequestor) };
            break;
          case "Approve":
            newList[1] = { ...item, disabled: !isAuthorized(permissions.ApprovalsApprove) };
            break;
          case "Reject":
            newList[2] = { ...item, disabled: !isAuthorized(permissions.ApprovalsReject) };
            break;
          default:
            break;
        }
      })
      setApproverActionList(newList);
    }
  }, [transferApproverActionData])

  const setRequestOptionDefault = (result: any, status: any) => {
    
    let reqOptionArr = [...requestOption]
    let items: any = []
    if ((transferApprovalRequestOption?.length != undefined && transferApprovalRequestOption?.length != 0)) {
      items = [...transferApprovalRequestOption];
      transferApprovalRequestOption?.forEach((item: any, index: number) => {
        if (item.key === index) {
          items?.splice(index, 1);
        }
      })
    }
    let arr: any = [];
    result[0]?.requestApprovalHistory?.forEach((i: any) => {
      arr[i] = {
        key: i,
        request: status
      }
      reqOptionArr[i] = status

    })
    dispatch(setTransferApprovalRequestOption([...items, ...arr]))
    setRequestOption(reqOptionArr)
  }

  useEffect(() => {  
    if (transferOrderByIdData?.orderId || afeOrderByIdData?.orderId) {
      transferOrderApprovalRequest.orderId = requesttype == CONSTANTS.AFEREQUEST ? afeOrderByIdData?.orderId : transferOrderByIdData?.orderId;
      transferOrderApprovalRequest.approverEmailId = getUserDetails?.emailId;
      transferOrderApprovalRequest.requestApproveVMs = []
      dispatch(setTransferOrderApprovalRequest(transferOrderApprovalRequest))
      let result: any = []
      if(requesttype == CONSTANTS.AFEREQUEST){
        result = afeOrderByIdData?.approvalHistory[0]?.approvalList?.filter((approvalHistory: any) => approvalHistory?.assignedUserEmail == getUserDetails?.emailId);
      }else{
        result = transferOrderByIdData?.approvalHistory[0]?.approvalList?.filter((approvalHistory: any) => approvalHistory?.assignedUserEmail == getUserDetails?.emailId);
      }
      
      let reqOptionArr = [...requestOption]
      let status = ''
      if(result?.length){
      if (result[0]?.status === 'Approved') {
        status = 'Approve'
        setRequestOptionDefault(result, status)
      }
      else if (result[0]?.status === 'Rejected') {
        status = 'Reject'
        setRequestOptionDefault(result, status)

      } else if (result[0]?.status === 'Pending Approval') {        
        let items: any = []
        if ((transferApprovalRequestOption?.length != undefined && transferApprovalRequestOption?.length != 0)) {
          items = [...transferApprovalRequestOption];
          transferApprovalRequestOption?.forEach((item: any, index: number) => {
            if (item.key === index) {
              items.splice(index, 1);
            }
          })
        }
        let arr: any = [];
        result[0]?.requestApprovalHistory?.forEach((x: any, i: any) => {
          if ((x?.status == 'Returned') || (x?.status == null && result[0]?.approvedDate != '' && result[0]?.approvedDate != null)) {
            arr[i] = {
              key: i,
              request: 'Request More Info'
            }
            reqOptionArr[i] = 'Request More Info'
          } else if (x?.status == 'Rejected') {
            arr[i] = {
              key: i,
              request: 'Reject'
            }
            reqOptionArr[i] = 'Reject'
          } else if (x?.status == 'Approved') {
            arr[i] = {
              key: i,
              request: 'Approve'
            }
            reqOptionArr[i] = 'Approve'
          }
          setRequestOption(reqOptionArr)
        })
        dispatch(setTransferApprovalRequestOption([...items, ...arr]))
      }
      } 
    }
  }, [JSON.stringify(transferOrderByIdData), assetOrderByIdIndex, getUserDetails?.emailId, afeOrderByIdData])

  useEffect(() => {
    if (transferOrderByIdData?.orderId) {
      dispatch(setTransferApprovalRequestOption([]))
    }
  }, [transferOrderByIdData.id])

  const [Popupcontent, setPopupcontent] = useState<any>({
    title: "",
    isDialogVisible: false,
    isTitleWarning: false,
    subtextcontent: "",
    primaryBtnText: "",
    outlineBtnText: "",
    isSingleConfirmationBtn: false,
    isCommentboxVisible: false,
    isCompletedReportVisible: false,
    titleImg: "",
    isCommentBoxRequire: false,
    outlineBtnnavigateTo: "",
    primaryBtnnavigateTo: "",
    actionby: "",
    value: ''
  });

  const hideDialog = useCallback(() => {
    setPopupcontent({ ...Popupcontent, isDialogVisible: false })
  }, [Popupcontent])

  const popupOutlinebtnOnclick = (item: any) => {
    if (item !== '') {
      dispatchNav(item);
      dispatch(setTransferApprovalRequestOption([]))
    }
    setRequestOption([...requestOption]);
    hideDialog();
  }

  const closeDialogHandler = () => {
    setRequestOption([...requestOption]);
    hideDialog();
  }

  const popupPrimarybtnOnclick = (item: any, comments: string, actionby: string, value: any) => {
    if (item !== '') {
      dispatchNav(item);
      dispatch(setTransferApprovalRequestOption([]))
    }
    let reqOptionArr = [...requestOption]
    switch (actionby) {
      case "Approve":
        reqOptionArr[assetOrderByIdIndex] = 'Approve'
        setRequestOption(reqOptionArr)
        break;
      case "Moreinfo":
        reqOptionArr[assetOrderByIdIndex] = 'Request More Info'
        setRequestOption(reqOptionArr)
        break;
      case "Rejected":
        reqOptionArr[assetOrderByIdIndex] = 'Reject'
        setRequestOption(reqOptionArr)
        break;
      default:
        break;
    }
    hideDialog();
    let arr = { 'requestId': 0, 'approverActionId': 0, 'comment': '', };
    arr['requestId'] = assetOrderByIdItem?.transferDispoReactivationAssetDetailId
    arr['approverActionId'] = value
    arr['comment'] = comments;
    let requestItems = [...transferOrderApprovalRequest.requestApproveVMs]
    requestItems = requestItems.filter(item => item?.requestId !== arr.requestId);
    transferOrderApprovalRequest.requestApproveVMs = [...requestItems, arr];
    transferOrderApprovalRequest.approverActionId = 0
    transferOrderApprovalRequest.comment = ''
    dispatch(setIsTransferItemAndOrderLevelApproval(null))
    dispatch(setTransferOrderApprovalRequest(transferOrderApprovalRequest))
  }

  useEffect(() => {
    
    if (requestOption?.[assetOrderByIdIndex]) {
      let items: any = []
      if ((transferApprovalRequestOption?.length != undefined && transferApprovalRequestOption?.length != 0)) {
        items = [...transferApprovalRequestOption];
        transferApprovalRequestOption?.forEach((item: any, index: number) => {
          if (item.key === index) {
            items?.splice(index, 1);
          }
        })
      }
      dispatch(setTransferApprovalRequestOption([...items, {
        key: assetOrderByIdIndex,
        request: requestOption[assetOrderByIdIndex]
      }]))

      if (!transferApprovalRequestOption?.length) {
        dispatch(setTransferApprovalRequestOption([...transferApprovalRequestOption, {
          key: assetOrderByIdIndex,
          request: requestOption[assetOrderByIdIndex]
        }]))
      }
    }
  }, [requestOption, assetOrderByIdIndex])

  const getRequestStyle = (id: number) => {
  const reqData = transferOrderApprovalRequest?.requestApproveVMs;
  if(reqData?.length > 0){
    const filter = reqData?.filter((item: any) => item.requestId === id);
    if(filter?.length){
      return (filter[0]?.approverActionId == "1" ? "Approve" : filter[0]?.approverActionId == "2" ? "Reject" : "")
    }
  }
}

    const approvesubtext = <><p>Are you sure you want to Approve the item</p><p>{(detailsByIdItem?.orderRequestType == CONSTANTS.TRANSFER_REQUEST) ? <b>{CONSTANTS.TRANSFER}</b> : (detailsByIdItem?.orderRequestType == CONSTANTS.DISPOSITION_REQUEST) ? <b>{CONSTANTS.DISPOSITION}</b> : <b>{CONSTANTS.REACTIVATION}</b>}</p></>
    const moreInfosubtext = <><p>Are you sure you want to request more information</p><p>{(detailsByIdItem?.orderRequestType == CONSTANTS.TRANSFER_REQUEST) ? <b>{CONSTANTS.TRANSFER}</b> : (detailsByIdItem?.orderRequestType == CONSTANTS.DISPOSITION_REQUEST) ? <b>{CONSTANTS.DISPOSITION}</b> : <b>{CONSTANTS.REACTIVATION}</b>}</p></>
    const rejectsubtext = <><p>Are you sure you want to Reject the item</p><p>{(detailsByIdItem?.orderRequestType == CONSTANTS.TRANSFER_REQUEST) ? <b>{CONSTANTS.TRANSFER}</b> : (detailsByIdItem?.orderRequestType == CONSTANTS.DISPOSITION_REQUEST) ? <b>{CONSTANTS.DISPOSITION}</b> : <b>{CONSTANTS.REACTIVATION}</b>}</p></>
  function itemLevelApproverActionChange(_ev: React.FormEvent<HTMLInputElement>, option: any): void {   
      if (option?.text === 'Approve') {
          setPopupcontent({ ...Popupcontent, titleImg: Approved, title: 'APPROVE', isDialogVisible: true, isTitleWarning: false, subtextcontent: approvesubtext, primaryBtnText: 'Yes', outlineBtnText: 'No', isSingleConfirmationBtn: false, isCommentboxVisible: true, isCompletedReportVisible: false, outlineBtnnavigateTo: "", primaryBtnnavigateTo: "", actionby: "Approve", value: option?.value, comment: "" })
      }
      if (option?.text === 'Request More Info') {
          setPopupcontent({ ...Popupcontent, titleImg: Moreinfo, title: 'REQUEST MORE INFO', isDialogVisible: true, isTitleWarning: false, subtextcontent: moreInfosubtext, primaryBtnText: 'Yes', outlineBtnText: 'No', isSingleConfirmationBtn: false, isCommentboxVisible: true, isCompletedReportVisible: false, outlineBtnnavigateTo: "", primaryBtnnavigateTo: "", actionby: "Moreinfo", value: option?.value, comment: "", isCommentBoxRequire: true })
      }
      if (option?.text === 'Reject') {
          setPopupcontent({ ...Popupcontent, titleImg: Rejected, title: 'REJECT', isDialogVisible: true, isTitleWarning: false, subtextcontent: rejectsubtext, primaryBtnText: 'Yes', outlineBtnText: 'No', isSingleConfirmationBtn: false, isCommentboxVisible: true, isCompletedReportVisible: false, outlineBtnnavigateTo: "", primaryBtnnavigateTo: "", actionby: "Rejected", value: option?.value, comment: "", isCommentBoxRequire : true })
      }
  }

  const isValidForPenaltyFee = (selectedOption?: any) => {
    if (selectedOption == CONSTANTS.DISPOSITION_CHOICES.WRITE_OFF_OWNED_ASSET_NO_TITLE || 
      selectedOption == CONSTANTS.DISPOSITION_CHOICES.WRITE_OFF_LEASED_ASSET_NO_TITLE ||
      selectedOption == CONSTANTS.DISPOSITION_CHOICES.WRITE_OFF_OWNED_ASSET_TITLED || 
      selectedOption == CONSTANTS.DISPOSITION_CHOICES.WRITE_OFF_LEASED_ASSET_TITLED) {
      return true
    } else {
      return false
    }
  }

  return (
    <AssetInformation
      transferOrderByIdData={transferOrderByIdData}
      searchFilter={searchFilter}
      searchFilterChange={searchFilterChange}
      getRequestStyle={getRequestStyle}
      isValidForPenaltyFee = {isValidForPenaltyFee}
      assetOrderByIdIndex = {assetOrderByIdIndex}
      assetOrderByIdItem = {assetOrderByIdItem}
      approverActionList={approverActionList}
      setPopupcontent={setPopupcontent}
      Popupcontent={Popupcontent}
      requestOption={requestOption}
      hideDialog={hideDialog}
      popupOutlinebtnOnclick={popupOutlinebtnOnclick}
      popupPrimarybtnOnclick={popupPrimarybtnOnclick}
      itemDetail={props.itemDetail}
      setRequestOption={setRequestOption}
      closeDialogHandler={closeDialogHandler}
      selectedOption={selectedOption}
      itemLevelApproverActionChange = {itemLevelApproverActionChange}
      detailsByIdItem = {detailsByIdItem}
      requesttype = {requesttype}
      afeOrderByIdData = {afeOrderByIdData}
    />
  );
};
export default AssetInformationContainer;
